import type { CampaignEventModule, CampaignEventType } from "./types";

export function campaignImageUrl(src: string, width: number) {
  return `/image/${src}?w=${width}&v=3`;
}

/** Ekran genişliğine göre görsel genişliği; image route bu boyutları önbellekler. */
export function preferredImageWidth() {
  if (typeof window === "undefined") return 828;
  const needed = Math.min(window.innerWidth, 560) * (window.devicePixelRatio || 1);
  return needed <= 640 ? 640 : needed <= 828 ? 828 : 1200;
}

export function isExternalUrl(url: string) {
  return /^https?:\/\//i.test(url);
}

/**
 * Olayı sayfa değişse bile ulaşacak şekilde gönderir. Önizlemede çağrılmaz;
 * bot ayıklaması backend'de yapılır.
 */
export function sendCampaignEvent(payload: {
  module: CampaignEventModule;
  event: CampaignEventType;
  creativeId?: number;
}) {
  if (typeof window === "undefined") return;
  const body = JSON.stringify({ ...payload, path: window.location.pathname.slice(0, 300) });
  try {
    if (navigator.sendBeacon?.("/api/site-campaign-event", new Blob([body], { type: "application/json" }))) return;
  } catch {
    // fetch ile dene
  }
  fetch("/api/site-campaign-event", {
    method: "POST",
    body,
    keepalive: true,
    headers: { "Content-Type": "application/json" },
  }).catch(() => undefined);
}
